import requests from "./httpService";

const WhatsAppServices = {
  getAllTemplates: async () => {
    return requests.get("/whatsapptemplate/");
  },
  getApprovedTemplates: async () => {
    return requests.get("/whatsapptemplate/approved");
  },
  addTemplate: async (body) => {
    return requests.post("/whatsapptemplate/add", body);
  },
  updateTemplate: async (id, body) => {
    return requests.put(`/whatsapptemplate/update/${id}`, body);
  },
  deleteTemplate: async (id) => {
    return requests.delete(`/whatsapptemplate/delete/${id}`);
  },
  checkTemplateStatus: async (id) => {
    return requests.get(`/whatsapptemplate/status/${id}`);
  },
  sendMessage: async (payload) => {
    return requests.post("/message/send", payload);
  },
  getAllMessages: async () => {
    return requests.get("/message/");
  },
  checkMessageStatus: async (id) => {
    return requests.get(`/message/status/${id}`);
  },
};

export default WhatsAppServices;
